import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5892bb64&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=5892bb64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5892bb64",
  null
  
)

export default component.exports